import React from "react";

const LOGO_URL = "https://scanix.in/website-assets/img/logo.png";

export function Logo({ size = "md", className = "", variant = "default" }) {
    const sizes = {
        sm: "h-6",
        md: "h-8",
        lg: "h-12",
        xl: "h-16",
    };
    const h = sizes[size] || sizes.md;
    return (
        <div className={`flex items-center ${className}`} data-testid="app-logo">
            <img
                src={LOGO_URL}
                alt="Scanix"
                className={`${h} w-auto object-contain select-none pointer-events-none ${
                    variant === "invert" ? "invert brightness-0" : ""
                }`}
                draggable={false}
            />
        </div>
    );
}
